import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  InputAdornment,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useMemo, useState } from "react";
import useAppGlobal from "src/context/useAppGlobal";
import useAuthGlobal from "src/context/useAuthGlobal";
import useWarehouseDetailDistribution from "src/hooks/warehouse/useWarehouseDetailDistribution";
import useWarehouseDistributionDetaillCreate from "src/hooks/warehouse/useWarehouseDistributionDetaillCreate";

export default function UpdatePercentageDialog({ childWarehouse, productModel }) {
  const { userMe } = useAuthGlobal();
  const { closeDialog } = useAppGlobal();
  const { data } = useWarehouseDetailDistribution({ id: userMe?.currentWarehouse?._id, productModel: productModel });
  const { trigger: update } = useWarehouseDistributionDetaillCreate({ id: userMe?.currentWarehouse?._id });
  const [distribution, setDistribution] = useState([]);

  useEffect(() => {
    const childWarehouses = data?.data?.[0]?.productModels?.[0]?.childWarehouses;

    if (!childWarehouses) return;

    setDistribution(
      childWarehouses.map((v) => ({
        percentage: v.percentage,
        childWarehouse: v.childWarehouse?._id,
      })),
    );
  }, [data]);

  const onUpdate = async () => {
    const res = await update({
      body: {
        distributes: {
          productModel: data?.data[0]?.productModels[0]?._id,
          childWarehouses: distribution,
        },
      },
    });
    if (res.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const total = useMemo(() => {
    const item = distribution?.reduce((acc, curr) => acc + curr?.percentage, 0);
    return item > 100;
  }, [distribution]);

  return (
    <>
      <DialogContent>
        <Stack>
          <Box
            display="flex"
            gap={2}
            mb={2}
          >
            <Typography fontWeight={700}>{data?.data[0]?.product?.name}</Typography>
          </Box>
          <TableContainer>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead
                sx={{
                  "& .MuiTableCell-head": {
                    backgroundColor: "grey.100",
                    fontWeight: 600,
                  },
                }}
              >
                <TableRow>
                  <TableCell align="center">Phân loại sản phẩm</TableCell>
                  <TableCell align="center">Kho con</TableCell>
                  <TableCell align="center">Tỷ lệ dung tích kho</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.data[0]?.productModels?.map((model) =>
                  model.childWarehouses.map((warehouse, index) => (
                    <TableRow key={`${model._id}-${warehouse.childWarehouse?._id}`}>
                      {index === 0 && (
                        <TableCell
                          align="center"
                          rowSpan={model.childWarehouses.length}
                        >
                          {model.name}
                        </TableCell>
                      )}
                      <TableCell align="center">{warehouse.childWarehouse?.name}</TableCell>

                      <TableCell align="center">
                        <TextField
                          value={distribution[index]?.percentage ?? ""}
                          variant="standard"
                          size="small"
                          error={Number(distribution[index]?.percentage) > 100 || total}
                          onChange={(e) => {
                            const item = [...distribution];
                            item[index] = {
                              ...item[index],
                              percentage: Number(e.target.value),
                            };
                            setDistribution(item);
                          }}
                          sx={{
                            width: 70,
                            "& input": {
                              textAlign: "center",
                            },
                          }}
                          slotProps={{
                            input: {
                              endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            },
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )),
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1, alignItems: "flex-end" }}>
        {total && (
          <Typography
            color="error"
            variant="caption"
          >
            Vượt qua mức cho phép
          </Typography>
        )}
        <Button
          disabled={total}
          onClick={onUpdate}
          fullWidth
          variant="contained"
        >
          Cập nhật
        </Button>
      </DialogActions>
    </>
  );
}
